var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"tp-textarea",class:_vm.textareaClass,attrs:{"placeholder":_vm.placeholder,"name":_vm.name,"rows":_vm.rows},domProps:{"value":_vm.modelValue},on:{"input":_vm.updateValue,"blur":_vm.handleBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }